import { gql } from '@apollo/client'
import PAGINATED_PAGE_INFO_FRAGMENT from 'apollo/fragments/PAGINATED_PAGE_INFO_FRAGMENT'

// CHATS

export default gql`
  query chats(
    $cursor: String
    $filters: ChatsFilterInput
    $order: CHAT_TYPE_ORDER
    $isProhibitedRole: Boolean = false
  ) {
    chats(first: 25, after: $cursor, order: $order, filters: $filters) {
      nodes {
        id
        inactive
        navigators {
          id
          full_name
          care_pods @skip(if: $isProhibitedRole) {
            name
          }
        }
        updated_at
        count_require_navigator_response_messages
        last_message_at
        member_user {
          id
          last_request_ago
          first_name
          last_name
          member {
            id
            organization {
              name
              third_party_admin {
                abbr
              }
            }
          }
        }
      }
      pageInfo {
        ...PAGINATED_PAGE_INFO_FRAGMENT
      }
    }
  }
  ${PAGINATED_PAGE_INFO_FRAGMENT}
`
